import { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  AUTH_ENDPOINTS_SKIP_GENERIC_LOGOUT,
  AUTH_LOGIN_URLS,
  getSessionErrorFromResponseData,
  urlMatchesAny,
} from './sessionErrorCodes';
import { sessionInvalidateGate } from './sessionInvalidateGate';
import { triggerAuthLogout } from './authLogoutBridge';

function dispatchForcedLogout() {
  triggerAuthLogout({ redirect: true });
}

export function handleAuthError(
  result: { error?: FetchBaseQueryError },
  args: string | FetchArgs,
) {
  if (
    !result.error ||
    (result.error.status !== 401 && result.error.status !== 403)
  ) {
    return;
  }

  const url = typeof args === 'string' ? args : args.url || '';
  const sessionCode = getSessionErrorFromResponseData(result.error.data);
  const isSessionError =
    result.error.status === 401 && sessionCode !== undefined;

  if (isSessionError) {
    if (!urlMatchesAny(url, AUTH_LOGIN_URLS)) {
      sessionInvalidateGate.handleSessionInvalidation(
        sessionCode,
        dispatchForcedLogout,
      );
    }
    return;
  }

  if (!urlMatchesAny(url, AUTH_ENDPOINTS_SKIP_GENERIC_LOGOUT)) {
    dispatchForcedLogout();
  }
}

export function handleAxiosAuthError(error: unknown) {
  const err = error as {
    response?: { status?: number; data?: unknown };
    config?: { url?: string };
  };
  const status = err.response?.status;
  if (status !== 401 && status !== 403) {
    return;
  }

  const url = err.config?.url || '';
  const sessionCode = getSessionErrorFromResponseData(err.response?.data);
  const isSessionError = status === 401 && sessionCode !== undefined;

  if (isSessionError) {
    if (!urlMatchesAny(url, AUTH_LOGIN_URLS)) {
      sessionInvalidateGate.handleSessionInvalidation(
        sessionCode,
        dispatchForcedLogout,
      );
    }
    return;
  }

  if (!urlMatchesAny(url, AUTH_ENDPOINTS_SKIP_GENERIC_LOGOUT)) {
    dispatchForcedLogout();
  }
}
